  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmIntroCookieNotice
   * @param  {service} $alert alert directive from Angular Strap: http://mgcrea.github.io/angular-strap/#/alerts
   * @param  {service} $cookies     Angular Cookie Provider: Provides read/write access to browser's cookies.
   * @description
   *   Show informatory notice to new users. A cookie is set upon clicking close. If the cookie exists do not show the notice. 
   * @example
   *   Usage:
   *        <rm-intro-cookie-notice></rm-intro-cookie-notice>
   */
rmOBA.directive('rmIntroCookieNotice', [
    '$alert',
    '$cookies', function(
        $alert,
        $cookies
    ) {
    return {
        restrict: 'E',
        templateUrl: 'directives/rmIntroCookieNotice/rmIntroCookieNotice.html',
        scope: true,
        link: function (scope) {

            scope.cookieNoticeCookie = $cookies.get('hideIntroNotice') || 0;
            scope.title = 'Please submit today\'s orders using this form';
            scope.content = 'There have been some technical problems with the main OBA website. This means that while OBA is unavailable you\'ll need to use this alternative order form. It should take only a couple of minutes more than normal - we\'re sorry for any inconvenience this may cause.';
                      
            /**
            * @memberof rmIntroCookieNotice
            * @function hideBanner
            * @desc Hide the intro notice and set a cookie so it does not show for the next 24 hours
            * @param {object} obj element object from click event
            * @param {object} $event event object from click event
            */               
            scope.hideBanner = function (obj, $event) {

                $cookies.put('hideIntroNotice', '1');
                $event.target.parentNode.parentNode.parentNode.removeChild($event.target.parentNode.parentNode);
            }
        }
    }
}]);